import Operation from './Operation.js';
import GenericSelection from './GenericSelection.js';

class MoveSelection extends GenericSelection {
    constructor(mix, step, selection, mixType) {
        super(mix, step, selection, mixType);
    }
  
    getEventsAfter(mixByType, step) {
        return mixByType.events.filter(x => x.step >= step);
    }

    executeByType(eventType, mixByType, mixType) {
        let eventsToMove = this.getEventsAfter(mixByType, this.start);
        for (let i in eventsToMove) {
            let event = eventsToMove[i];
            let originalStep = event.step;
            let diff = this.step - this.start;
            event.setTime(undefined, event.step + diff);
            if (event.subEvents) {
                for (let i in event.subEvents) {
                    let subEvent = event.subEvents[i];
                    subEvent.step += diff;
                }
            }
        }
    }
}

export default MoveSelection;
